<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <FormUser @submit="submit" :title="'Update User'" :form="form" :mode="'edit'"></FormUser>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FormUser from '@/views/admin/user/FormUser'
import axios from 'axios'

export default {
  name: 'updateuser',
  components: {
    FormUser
  },  
  data () {
    return {
      form: {}
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    }
  },
  methods: {
    submit (form) {
      let scope = this; 

      form._id = scope.id;
      form.user = scope.$store.getters.currentUser.id

      axios.put(process.env.VUE_APP_API + '/user/' + form._id, form, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.$router.push('/admin/users/list')
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
  created () {
    let scope = this;
    axios.get(process.env.VUE_APP_API + '/user/' + scope.id, {
      headers: {
        Authorization: 'JWT ' + scope.$localStorage.get('holly-fi-token')
        }
      })
        .then(function (response) {
          scope.form = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
